import { render, staticRenderFns } from "./ConfiguratorLevel1Shared.vue?vue&type=template&id=256332af&"
import script from "./ConfiguratorLevel1Shared.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorLevel1Shared.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguratorLevel1Shared.vue?vue&type=style&index=0&id=256332af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports